import { render, staticRenderFns } from "./SupportMaterials.vue?vue&type=template&id=129e8a2c&scoped=true&"
import script from "./SupportMaterials.vue?vue&type=script&lang=js&"
export * from "./SupportMaterials.vue?vue&type=script&lang=js&"
import style0 from "./SupportMaterials.vue?vue&type=style&index=0&id=129e8a2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129e8a2c",
  null
  
)

component.options.__file = "SupportMaterials.vue"
export default component.exports